import { createContext, useContext } from 'react';

export interface IsNavigationCondensedContext {
  isNavigationCondensed: boolean;
  isNavigationForceCondensed: boolean;
  setIsNavigationCondensed: (isCondensed: boolean) => void;
  setIsNavigationForceCondensed: (isForceCondensed: boolean) => void;
}

export const IsNavigationCondensedContext = createContext<IsNavigationCondensedContext>({
  isNavigationCondensed: false,
  setIsNavigationCondensed: () => null,
  isNavigationForceCondensed: false,
  setIsNavigationForceCondensed: () => null,
});

export const IsNavigationCondensedProvider = IsNavigationCondensedContext.Provider;

export function useIsNavigationCondensed() {
  const { isNavigationCondensed } = useContext(IsNavigationCondensedContext);
  return isNavigationCondensed;
}
